document.addEventListener('click', function (e) {
  var tab = e.target.closest('.payment-toggle__tab');
  if (!tab) return;
  var container = tab.closest('.payment-toggle');
  if (!container) return;
  container.querySelectorAll('.payment-toggle__tab').forEach(function (t) { t.classList.remove('is-active'); });
  tab.classList.add('is-active');
  var payment = tab.dataset.payment;
  container.querySelectorAll('.payment-toggle__price').forEach(function (p) {
    p.hidden = p.dataset.paymentDisplay !== payment;
  });
});
